<template>
  <svg
    id="Draw_2"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    preserveAspectRatio="xMaxYMin meet"
    width="555.911"
    height="341.918"
    viewBox="0 0 158 85.456"
  >
    <title></title>
    <defs>
      <linearGradient
        id="linear-gradient"
        x1="0.5"
        y1="1"
        x2="0.5"
        gradientUnits="objectBoundingBox"
      >
        <stop
          offset="0"
          stop-color="gray"
          stop-opacity="0.251"
        />
        <stop
          offset="0.54"
          stop-color="gray"
          stop-opacity="0.122"
        />
        <stop
          offset="1"
          stop-color="gray"
          stop-opacity="0.102"
        />
      </linearGradient>
      <linearGradient
        id="linear-gradient-2"
        x1="0"
        y1="0.5"
        x2="1"
        y2="0.5"
        xlink:href="#linear-gradient"
      />
    </defs>
    <g id="groupedComponents">
      <path
        id="background1"
        data-name="Tracé 1572"
        class="background1"
        d="M123.893,219.377c3.052-.174,6.839-2.244,9.784-3.16q5.227-1.621,10.5-3.12,18.342-5.219,37.078-8.894,1.748-.344,3.5-.671a24.792,24.792,0,0,0-8.184-9.829,25.152,25.152,0,0,0,.138-2.594,24.619,24.619,0,0,0-24.445-24.792,24.056,24.056,0,0,0-11.864,3.114c-9.557-6.287-22.031-10.092-35.679-10.092-19.393,0-36.418,7.683-46.065,19.252l45.339,7.66,27.807,4.7c-31.7.946-63.5,1.887-95.108-.334a25.056,25.056,0,0,0-3.607,31.627h0c0,.5.021.987.058,1.475.805.231,1.583.454,2.28.6q16.8,3.548,33.806,5.939c-8.357,5.153-18.534,5.882-28.174,8.064a28.25,28.25,0,0,0,17.993,6.215H163.061c11.263,0,20.392-7.84,20.392-17.514h0a24.886,24.886,0,0,0,3.315-9.1C165.927,219.933,144.826,218.186,123.893,219.377Z"
        transform="translate(-28.91 -159.078)"
      />
      <path
        id="Tracé_1573"
        data-name="Tracé 1573"
        class="background2"
        d="M185.979,212.163a24.86,24.86,0,0,0-10.5-20.36,25.513,25.513,0,0,0,.138-2.592,24.619,24.619,0,0,0-24.445-24.788,24.07,24.07,0,0,0-11.865,3.113c-9.557-6.29-22.033-10.1-35.681-10.1-22.2,0-41.308,10.075-49.783,24.523-.471-.028-.945-.043-1.423-.043A24.622,24.622,0,0,0,27.98,206.712,24.933,24.933,0,0,0,32,220.339h0c0,12.319,11.627,22.306,25.965,22.306H161.982c11.261,0,20.39-7.842,20.39-17.515h0a24.931,24.931,0,0,0,3.607-12.967Z"
        transform="translate(-27.98 -157.44)"
      />
      <path
        id="Tracé_1574"
        data-name="Tracé 1574"
        class="cls-3"
        d="M742.906,256.286a1.538,1.538,0,0,0-.674-.3c-.258-.059-.522-.1-.784-.138l-3.4-.49a4.006,4.006,0,0,0-1.041-.055,1.322,1.322,0,0,0-.906.47.706.706,0,0,0-.157.442,1.166,1.166,0,0,0,.155.459,1.535,1.535,0,0,1,.084.2,4.653,4.653,0,0,0,.121.463.393.393,0,0,0,.058.091.151.151,0,0,1,0,.024c-.037.191.083.389.029.573-.047.157-.2.253-.3.384a.577.577,0,0,0-.014.637c.1.16.291.269.345.453.07.242-.12.475-.29.662a10.254,10.254,0,0,0-.865,1.09.675.675,0,0,0-.138.325c-.015.24.215.452.175.691-.032.188-.215.3-.374.414a2.329,2.329,0,0,0-1.1,1.711,5.994,5.994,0,0,0-1.337-3.038,2.174,2.174,0,0,1-.5-.778c-.03-.12-.036-.249-.077-.365-.138-.366-.577-.523-.769-.86-.138-.238-.138-.543-.309-.751s-.441-.255-.588-.457a2.919,2.919,0,0,1-.188-.425.93.93,0,0,0-.255-.307.753.753,0,0,0-.064-.046.22.22,0,0,0,.073-.163c0-.162-.16-.268-.3-.348-.18-.1-.355-.213-.526-.327a1.231,1.231,0,0,0,.471-.385,1.266,1.266,0,0,0,.18-.829,1.046,1.046,0,0,0-.247-.634c-.087-.093-.2-.159-.287-.246a2.017,2.017,0,0,1-.414-.887,1.8,1.8,0,0,0-.711-1.069c-.182-.106-.395-.156-.573-.268a.5.5,0,0,1-.265-.526c.041-.138.17-.233.257-.351a.7.7,0,0,0-.175-.967c-.1-.065-.228-.122-.249-.24a.439.439,0,0,1-.32-.34,1.311,1.311,0,0,1,0-.492q.054-.385.106-.768a.5.5,0,0,0,.384,0,3.383,3.383,0,0,0,.414.541,5.409,5.409,0,0,1,.967,1.678,1.01,1.01,0,0,0,.363.586c.07.04.151.061.22.1a.82.82,0,0,1,.215.221c.166.22.331.438.5.657l.008.033a.194.194,0,0,0,.022.055.184.184,0,0,0,.119.061,2.013,2.013,0,0,0,1.519-.052c.4-.249.572-.74.909-1.069.239-.233.577-.414.645-.743a2.447,2.447,0,0,1-.238-.087c.069-.069.138-.149.232-.24a2.923,2.923,0,0,0,.367-.438,2.823,2.823,0,0,0,.276-.619q.4-1.138.8-2.277c.127-.359.254-.721.414-1.07.166-.378.362-.742.543-1.113a14.78,14.78,0,0,0,1.074-3.025,1.1,1.1,0,0,0,.043-.441,1.162,1.162,0,0,0-.392-.6,2.878,2.878,0,0,0-.588-.488.967.967,0,0,0-.737-.119,1.065,1.065,0,0,0-.657.829,8.7,8.7,0,0,0-.086,1.1c-.05.532-.232,1.046-.276,1.579-.023.308,0,.62-.037.928a3.386,3.386,0,0,1-.414,1.144,7.4,7.4,0,0,1-1.786,2.2c-.084.07-.171.138-.254.214a1.325,1.325,0,0,1,.018-.18,1.086,1.086,0,0,0-.175.062.525.525,0,0,0-.021-.207c-.11-.33-.6-.414-.691-.75a1.536,1.536,0,0,1-.023-.251,6.394,6.394,0,0,0-.3-.829,3.538,3.538,0,0,0-.138-.8,2.227,2.227,0,0,0-.367-.414,1.625,1.625,0,0,1-.349-.659c-.018-.068-.034-.138-.054-.206a.942.942,0,0,0-.05-.454c-.126-.312-.45-.512-.568-.829-.091-.246-.051-.552-.224-.743a.809.809,0,0,0-.327-.2,7.282,7.282,0,0,0-1.971-.465,1.678,1.678,0,0,1-1.066-.32c-.316-.309-.331-.866-.7-1.1a.838.838,0,0,0-1.04.242,1.312,1.312,0,0,0-.105.138,1.48,1.48,0,0,1-.029-.566c0-.047.01-.1.014-.138a2.762,2.762,0,0,0,1.5-1.182v.008l.017.043c.04.1.1.2.2.209h0a.276.276,0,0,0,.171-.062,1.421,1.421,0,0,0,.229-.2q.052-.058.1-.12a1.565,1.565,0,0,0,.163-.276,1.642,1.642,0,0,0,.138-.463c.025-.16.028-.325.055-.485a2.979,2.979,0,0,1,.1-.366c.014-.04.028-.08.04-.12s.03-.094.044-.138a3.2,3.2,0,0,0,.138-.876v-.149a1.457,1.457,0,0,0-.464-1.029c-.237-.195-.552-.276-.726-.54a2.571,2.571,0,0,1-.2-.612,1.381,1.381,0,0,0-1.086-.976,1.208,1.208,0,0,0-.859.236h0l-.019.015h0a1.381,1.381,0,0,0-.343.381,1.139,1.139,0,0,1-.486-.276c-.138-.128-.244-.29-.384-.414a.987.987,0,0,0-.983-.207,1.175,1.175,0,0,0-.7.805,2.808,2.808,0,0,1-.221.849c-.123.185-.325.276-.465.445a.837.837,0,0,0-.174.369h0a1,1,0,0,0-.023.231h0a.419.419,0,0,0,.008.1v.017a.736.736,0,0,0,.023.112h0a.966.966,0,0,0,.206.378.909.909,0,0,0,.333.24,1.347,1.347,0,0,0,.16.051l.164.037.058.014a2.754,2.754,0,0,0-.077,2.432,1.1,1.1,0,0,1-.014.116,9.553,9.553,0,0,0,.072,1.628.874.874,0,0,1-.1.62,1.176,1.176,0,0,1-.2.178c.075-.1.151-.192.228-.287a.985.985,0,0,0-.779-.2,3.609,3.609,0,0,0-1.519.464,1.7,1.7,0,0,1-.981.373c-.209-.023-.414-.138-.617-.083a1.253,1.253,0,0,0-.316.188.428.428,0,0,1-.26.08,5.6,5.6,0,0,0-.812-.664,6.4,6.4,0,0,1-.808-.866c-.447-.54-.894-1.081-1.333-1.627a3.132,3.132,0,0,1-.815-1.541,1.49,1.49,0,0,1-.01-.175,4.457,4.457,0,0,1,.1-.829.413.413,0,0,0,0-.2c-.041-.138-.2-.189-.337-.22h0c.018-.106.03-.215.037-.319a24.213,24.213,0,0,1,.244-3.558,2.418,2.418,0,0,1,.573-1.225c.5-.51,1.348-.633,1.735-1.236a1.41,1.41,0,0,0-.211-1.657,2.092,2.092,0,0,0-1.627-.6.84.84,0,0,0-.474.127,1.007,1.007,0,0,0-.287.436l-.592,1.44a8.7,8.7,0,0,0-.434,1.157c-.166.6-.2,1.243-.334,1.853a4.82,4.82,0,0,1-.468,1.487c-.185.486-.385.967-.552,1.463-.041.124-.186.493-.276.829a.5.5,0,0,0-.094.07,2.491,2.491,0,0,0-.2.291c-.126.166-.33.254-.468.414s-.167.454.025.534a.565.565,0,0,0,.12.026.392.392,0,0,1,.333.547c-.03.215-.138.414-.156.63a1.7,1.7,0,0,0,.4,1.057,9.1,9.1,0,0,0,.737.993c.195.218.414.414.61.624.747.768,1.341,1.666,2.012,2.5a5.541,5.541,0,0,0,.819.859,6.165,6.165,0,0,0,.62.427l1.155.732a1.265,1.265,0,0,0,.436.206.581.581,0,0,0,.155,0c.007.035.012.068.021.1a6.079,6.079,0,0,1,.309,1.059c.022.369-.011.746.015,1.119.025.344.1.691.12,1.029a6.612,6.612,0,0,1-.276,1.934,11.529,11.529,0,0,1-.829,2.733,1.608,1.608,0,0,0-.276.738.384.384,0,0,0,.008.1h0l-.207.117c-.061.035-.122.069-.177.1a1.478,1.478,0,0,0-.651.656c-.087.239-.047.512-.152.744a.321.321,0,0,1-.017.03c-.11.215-.33.376-.38.612h0c-.037.181.035.373,0,.552v.007a2.008,2.008,0,0,0-.075.276.332.332,0,0,0,.008.091.526.526,0,0,0,.166.269,1.11,1.11,0,0,0,.162.128q.089.058.182.108l.036.019c.052.028.1.054.159.079l.036.015c.062.028.126.052.189.075l.044.014c.05.017.1.032.152.044l.035.011.032.007.138.029.051.01q.091.015.186.025h.055c.047,0,.092.007.138.008h.253a1.543,1.543,0,0,0,.195-.018h.021c.058-.008.116-.018.174-.03l.044-.01c.054-.012.108-.025.161-.041l.029-.008c.065-.019.13-.04.193-.065a5.074,5.074,0,0,0,.638-.316c.138-.076.276-.153.414-.224a3.228,3.228,0,0,1,.315-.138,1.778,1.778,0,0,1,.829-.138,3.252,3.252,0,0,1,.414.084v.046q.168.994.333,1.989a4.053,4.053,0,0,1,.572-.344,1.271,1.271,0,0,0-.073.311,1.24,1.24,0,0,0,0,.247.536.536,0,0,1-.039.38c-.048.064-.138.1-.164.171a.584.584,0,0,0-.014.225.359.359,0,0,1-.329.334.525.525,0,0,1-.209.616.731.731,0,0,0-.16.1.478.478,0,0,0-.093.209,3.69,3.69,0,0,1-1.081,1.777,3.477,3.477,0,0,0-.534.522,2.376,2.376,0,0,0-.242.476q-.553,1.351-1.122,2.7a6,6,0,0,0-.481,1.559c-.166,1.489-1.492,2.751-1.243,4.229a2.072,2.072,0,0,0,.431,1.01,2.542,2.542,0,0,0,1.1.678,20.111,20.111,0,0,0,3.306.869l1.757.36a7.68,7.68,0,0,0,1.047.166,6.854,6.854,0,0,1,1.272.1,3.946,3.946,0,0,0,.764.2c.227.012.505-.036.639.149s.03.43.157.594c.2.261.7,0,.925.246a1.146,1.146,0,0,1,.138.305.552.552,0,0,0,.138.174,1.165,1.165,0,0,1,.017.236,4.074,4.074,0,0,1-.2.942q-.249.841-.5,1.684a3.725,3.725,0,0,0-.138.608,1.452,1.452,0,0,0,0,.3.827.827,0,0,0,.5.72.909.909,0,0,0,.671-.083,2.962,2.962,0,0,0,.552-.373,3.772,3.772,0,0,0,.8-.82c.69-1.033.467-2.431.952-3.573a17.082,17.082,0,0,0,1.157-2.185.874.874,0,0,0,.017-.472.979.979,0,0,0-.656-.533h-.012a5.658,5.658,0,0,0-.691-.2c-.058-.012-.117-.022-.177-.032a1.084,1.084,0,0,1-.305-.4.925.925,0,0,0-.065-.239.248.248,0,0,0-.2-.11c-.138-.014-.323.036-.474.025-.308-.022-.512-.325-.789-.464a1.61,1.61,0,0,0-.87-.084.8.8,0,0,1-.315-.019,1.183,1.183,0,0,1-.331-.228,1.389,1.389,0,0,0-1.217-.244,1.327,1.327,0,0,1-.414.094c-.269-.015-.46-.256-.659-.438a7.908,7.908,0,0,0-1.979-.957.452.452,0,0,1-.238-.2c-.076-.188.1-.376.25-.5l1.135-.943c1.243-1.033,2.8-1.811,3.374-3.326a1.924,1.924,0,0,1,.276-.568.768.768,0,0,1,.153-.138,1.16,1.16,0,0,1,.849-.166,2.868,2.868,0,0,1,1,.436q.742.449,1.443.967a12.777,12.777,0,0,1,1.319,1.083c.725.691,1.329,1.51,2,2.254a6.438,6.438,0,0,0,2.385,1.8,3.07,3.07,0,0,0,2.877-.257,4.836,4.836,0,0,0,1.463-3.058,4.943,4.943,0,0,0,.927-1.934c.159-.427.362-.829.533-1.254.2-.5.365-1.016.525-1.532a7.361,7.361,0,0,0,.367-1.6,12.628,12.628,0,0,1,.077-2.584,9.533,9.533,0,0,0,.923-.355,4.571,4.571,0,0,1,1.461-.126h.032a.754.754,0,0,0,.486-.115.774.774,0,0,0,.2-.588A1.8,1.8,0,0,0,742.906,256.286ZM722.9,232.728a1.026,1.026,0,0,1-.349.025Z"
        transform="translate(-613.87 -216.753)"
      />
      <path
        id="man-neck"
        data-name="Tracé 1575"
        class="man-skin"
        d="M789.4,311.3a1.519,1.519,0,0,1-.575.305l-.979.351a3.648,3.648,0,0,1-1.648.314,5.464,5.464,0,0,1-1.86-.481c-.309-.378.775-.935,1.145-1.254a1.567,1.567,0,0,0,.232-.2.833.833,0,0,0,.1-.617,9.527,9.527,0,0,1-.072-1.626,3.292,3.292,0,0,1,.055-.385c.138-.635.729-.4,1.2-.235a9.357,9.357,0,0,1,1.623.7,1.165,1.165,0,0,1,.4.34,1.727,1.727,0,0,1,.09,1.1,1.035,1.035,0,0,0,.162.812,2.081,2.081,0,0,1,.261.276A.518.518,0,0,1,789.4,311.3Z"
        transform="translate(-679.83 -286.592)"
      />
      <path
        id="man-left-arm"
        data-name="Tracé 1576"
        class="man-skin"
        d="M714.882,233.175c.138-.612.169-1.243.334-1.849a8.653,8.653,0,0,1,.434-1.153l.609-1.421a1,1,0,0,1,.287-.435.851.851,0,0,1,.474-.127,2.111,2.111,0,0,1,1.627.6,1.4,1.4,0,0,1,.211,1.648c-.387.6-1.231.725-1.735,1.233a2.415,2.415,0,0,0-.573,1.222,24.082,24.082,0,0,0-.244,3.548,1.176,1.176,0,0,1-.414.981,1.209,1.209,0,0,1-.619.12l-.906.015c-.152,0-.7.1-.8-.019-.177-.2.227-1.2.3-1.42.163-.493.363-.974.552-1.458A4.849,4.849,0,0,0,714.882,233.175Z"
        transform="translate(-618.839 -218.416)"
      />
      <path
        id="man-left-shoe"
        data-name="Tracé 1577"
        class="shoes"
        d="M829.927,570.688a17.306,17.306,0,0,1-1.157,2.181c-.485,1.139-.267,2.533-.952,3.563a3.764,3.764,0,0,1-.8.822,2.959,2.959,0,0,1-.552.372.908.908,0,0,1-.671.083.826.826,0,0,1-.5-.718,1.446,1.446,0,0,1,0-.3,3.709,3.709,0,0,1,.138-.606q.249-.838.5-1.679a4.063,4.063,0,0,0,.2-.939c.018-.348-.2-.8-.109-1.126.043-.146.2-.276.276-.4a2.309,2.309,0,0,0,.238-.565,3.511,3.511,0,0,1,.428-1.121,2.63,2.63,0,0,1,.539-.5,1.426,1.426,0,0,1,.514-.289,1.257,1.257,0,0,1,.552.026,5.4,5.4,0,0,1,.691.2h.012a.967.967,0,0,1,.656.532A.87.87,0,0,1,829.927,570.688Z"
        transform="translate(-715.177 -512.541)"
      />
      <path
        id="man-right-shoe"
        data-name="Tracé 1578"
        class="shoes"
        d="M919.206,440.284a.766.766,0,0,1-.2.587.754.754,0,0,1-.486.115h-.037a4.655,4.655,0,0,0-1.461.126,5.524,5.524,0,0,1-1.051.376,2.565,2.565,0,0,1-1.44-.464,14.336,14.336,0,0,0-1.308-.621c-.293-.12-.891-.2-1.032-.518a4.735,4.735,0,0,1-.122-.461,1.536,1.536,0,0,0-.084-.2,1.167,1.167,0,0,1-.155-.457.705.705,0,0,1,.157-.442,1.324,1.324,0,0,1,.9-.465,4.007,4.007,0,0,1,1.041.055l3.4.489a7.954,7.954,0,0,1,.784.138,1.539,1.539,0,0,1,.674.3A1.746,1.746,0,0,1,919.206,440.284Z"
        transform="translate(-789.762 -399.117)"
      />
      <path
        id="man-pants"
        data-name="Tracé 1579"
        class="secondaire"
        d="M773.7,448.593c-.414.874-.116,1.909-.191,2.875a7.331,7.331,0,0,1-.367,1.594c-.16.514-.32,1.029-.525,1.527-.171.414-.374.829-.533,1.251a5.02,5.02,0,0,1-.927,1.934,4.809,4.809,0,0,1-1.463,3.049,3.061,3.061,0,0,1-2.877.257,6.437,6.437,0,0,1-2.385-1.8c-.675-.744-1.279-1.555-2-2.248a12.566,12.566,0,0,0-1.322-1.081q-.7-.51-1.443-.958a2.891,2.891,0,0,0-1-.435,1.16,1.16,0,0,0-.849.166.771.771,0,0,0-.153.138,1.9,1.9,0,0,0-.276.566c-.58,1.511-2.137,2.287-3.38,3.317l-1.135.941c-.155.128-.326.316-.25.5a.452.452,0,0,0,.237.2,7.9,7.9,0,0,1,1.979.954c.2.182.389.423.659.436a1.324,1.324,0,0,0,.414-.093,1.393,1.393,0,0,1,1.217.243,1.182,1.182,0,0,0,.331.228.8.8,0,0,0,.315.019,1.681,1.681,0,0,1,.87.084c.264.131.481.441.789.463.151.011.33-.039.474-.025a.248.248,0,0,1,.2.111.916.916,0,0,1,.065.238c.057.195.247.314.372.474a1.309,1.309,0,0,1,.2.891,3.8,3.8,0,0,1-1.21,2.544,1.5,1.5,0,0,1-.744.414.691.691,0,0,1-.738-.327,1.134,1.134,0,0,0-.138-.3c-.222-.244-.721.015-.925-.246-.127-.163-.036-.424-.157-.592s-.414-.138-.639-.148a4.055,4.055,0,0,1-.764-.2,6.858,6.858,0,0,0-1.272-.1,7.679,7.679,0,0,1-1.047-.166l-1.757-.359a20.826,20.826,0,0,1-3.306-.866,2.662,2.662,0,0,1-1.1-.677,2.072,2.072,0,0,1-.431-1.008c-.25-1.474,1.076-2.733,1.243-4.218a5.917,5.917,0,0,1,.481-1.555q.562-1.348,1.121-2.7a2.4,2.4,0,0,1,.235-.478,3.467,3.467,0,0,1,.535-.521,3.678,3.678,0,0,0,1.081-1.773.479.479,0,0,1,.093-.209.776.776,0,0,1,.16-.1.525.525,0,0,0,.209-.615.359.359,0,0,0,.329-.334.577.577,0,0,1,.014-.224c.033-.072.116-.108.164-.171a.534.534,0,0,0,.039-.378,1.23,1.23,0,0,1,0-.247,1.269,1.269,0,0,1,.37-.772c.33-.325.8-.24,1.255-.318a7.188,7.188,0,0,0,1.326-.424,13.025,13.025,0,0,1,3.744-.866,8.174,8.174,0,0,1,3.781.6,2.149,2.149,0,0,1,.487.276.924.924,0,0,1,.255.305,2.845,2.845,0,0,0,.188.424c.148.2.427.267.588.457s.175.512.309.749c.192.337.637.493.769.859.041.116.047.243.077.363a2.077,2.077,0,0,0,.5.776,5.968,5.968,0,0,1,1.337,3.038,2.311,2.311,0,0,1,1.1-1.707c.159-.1.342-.218.374-.406.04-.238-.191-.449-.175-.691a.677.677,0,0,1,.138-.323,10.216,10.216,0,0,1,.865-1.087c.17-.186.36-.414.29-.66-.054-.184-.242-.291-.345-.452a.575.575,0,0,1,.014-.635c.1-.131.25-.227.3-.383.054-.184-.066-.383-.029-.572a.707.707,0,0,1,.284-.369,2.877,2.877,0,0,1,3.511.33A1.31,1.31,0,0,1,773.7,448.593Z"
        transform="translate(-647.243 -406.542)"
      />
      <path
        id="man-right-shoe-bottom"
        data-name="Tracé 1580"
        class="shoes"
        d="M919.181,440.284a.765.765,0,0,1-.2.587.754.754,0,0,1-.486.115h-.037c.057-.287.406-.452.467-.743a.657.657,0,0,0-.152-.5,2.49,2.49,0,0,0-1.243-.782,8.234,8.234,0,0,0-4.152-.311,4.18,4.18,0,0,0-1.091.336,3.552,3.552,0,0,0-.331.235,1.166,1.166,0,0,1-.155-.457.706.706,0,0,1,.157-.442,1.325,1.325,0,0,1,.9-.465,4,4,0,0,1,1.041.055l3.4.489c.262.037.526.075.784.138a1.538,1.538,0,0,1,.674.3A1.734,1.734,0,0,1,919.181,440.284Z"
        transform="translate(-789.736 -399.117)"
      />
      <path
        id="man-left-shoe-bottom"
        data-name="Tracé 1581"
        class="shoes"
        d="M829.927,572.22a17.306,17.306,0,0,1-1.157,2.181c-.485,1.139-.267,2.533-.952,3.563a3.768,3.768,0,0,1-.8.822,2.959,2.959,0,0,1-.552.372.908.908,0,0,1-.671.083.826.826,0,0,1-.5-.718,1.447,1.447,0,0,1,0-.3l.008.022c.12.29.316.594.626.645a.847.847,0,0,0,.638-.225,3.945,3.945,0,0,0,.974-1.438,5.986,5.986,0,0,0,.467-1.192c.055-.235.081-.475.138-.71.262-1.141,1.156-2.072,1.353-3.228a.787.787,0,0,0,.011-.242,1.225,1.225,0,0,0-.119-.3,1.493,1.493,0,0,1-.1-.334.967.967,0,0,1,.656.532A.868.868,0,0,1,829.927,572.22Z"
        transform="translate(-715.177 -514.073)"
      />
      <path
        id="man-left-leg-back"
        data-name="Tracé 1582"
        class="dark"
        d="M789.42,513.743a2,2,0,0,1-.623.851,3.039,3.039,0,0,1-1.341.58,1.334,1.334,0,0,1-.691-.008c-.307-.106-.528-.394-.841-.477a5.751,5.751,0,0,0-.691-.04,2.45,2.45,0,0,1-1.052-.616c-1.007-.757-2.329-1-3.335-1.758a.308.308,0,0,1-.108-.112.334.334,0,0,1-.021-.156,3.177,3.177,0,0,1,.3-1.327,4.636,4.636,0,0,1,.569-.811,24.6,24.6,0,0,1,2.888-3.15,4.378,4.378,0,0,1,1.519-.932,2.277,2.277,0,0,1,1.331-.025.768.768,0,0,0-.153.138,1.9,1.9,0,0,0-.276.566c-.581,1.512-2.138,2.288-3.381,3.319l-1.135.941c-.155.128-.326.316-.25.5a.451.451,0,0,0,.238.2,7.9,7.9,0,0,1,1.979.954c.2.182.39.423.659.436a1.324,1.324,0,0,0,.414-.093,1.393,1.393,0,0,1,1.217.243,1.185,1.185,0,0,0,.331.228.8.8,0,0,0,.315.019,1.681,1.681,0,0,1,.87.084c.264.131.481.441.789.463C789.1,513.779,789.277,513.726,789.42,513.743Z"
        transform="translate(-676.756 -457.577)"
      />
      <path
        id="man-left-bottom-jacket"
        data-name="Tracé 1583"
        class="man-jacket"
        d="M743.8,396.88a1.467,1.467,0,0,0-.649.652c-.088.239-.047.512-.153.744s-.345.394-.4.642c-.037.181.036.372,0,.552a2.38,2.38,0,0,0-.076.287c-.014.206.163.373.336.488a2.8,2.8,0,0,0,2.509.276,11.343,11.343,0,0,0,1.055-.54,2.086,2.086,0,0,1,1.137-.276c.228.025.446.108.674.138a.707.707,0,0,0,.631-.188.787.787,0,0,0,.138-.327,4.892,4.892,0,0,0-.077-2.324c-.182-.762-.459-1.5-.653-2.254a10.343,10.343,0,0,0-.475-1.67,2.191,2.191,0,0,0-1.161-1.229.217.217,0,0,0-.138-.018.234.234,0,0,0-.09.066,4.247,4.247,0,0,0-.947,1.594c-.217.662-.276,1.363-.475,2.027a2.077,2.077,0,0,1-.414.858A4.734,4.734,0,0,1,743.8,396.88Z"
        transform="translate(-643.839 -359.458)"
      />
      <path
        id="man-left-bottom-jacket"
        data-name="Tracé 1584"
        class="man-jacket"
        d="M749.027,399.263a.806.806,0,0,1-.145.327.7.7,0,0,1-.631.186c-.226-.028-.445-.112-.673-.138a2.083,2.083,0,0,0-1.137.276c-.354.177-.691.4-1.057.539a2.788,2.788,0,0,1-1.675.1,2.7,2.7,0,0,1-.829-.365.594.594,0,0,1-.336-.487,2.37,2.37,0,0,1,.076-.286c.036-.181-.036-.372,0-.552.052-.249.293-.414.4-.644s.065-.5.152-.743a1.473,1.473,0,0,1,.65-.653,4.963,4.963,0,0,0,.784-.505.793.793,0,0,0,.073-.1,2.488,2.488,0,0,0,.329-.761c.2-.666.258-1.366.474-2.029a4.255,4.255,0,0,1,.949-1.592.208.208,0,0,1,.088-.066.221.221,0,0,1,.138.017,2.207,2.207,0,0,1,1.162,1.231,10.877,10.877,0,0,1,.475,1.668c.193.758.471,1.494.653,2.255A4.914,4.914,0,0,1,749.027,399.263Z"
        transform="translate(-643.856 -359.396)"
      />
      <path
        id="man-neck-shadow"
        data-name="Tracé 1585"
        class="dark"
        d="M798.224,309.641a2.762,2.762,0,0,1-3.364-1.519,3.279,3.279,0,0,1,.055-.385c.138-.635.729-.4,1.2-.235a9.357,9.357,0,0,1,1.623.7,1.164,1.164,0,0,1,.4.34A1.7,1.7,0,0,1,798.224,309.641Z"
        transform="translate(-688.947 -286.618)"
      />
      <circle
        id="man-face"
        data-name="Ellipse 26"
        class="man-skin"
        cx="2.762"
        cy="2.762"
        r="2.762"
        transform="translate(105.681 17.49)"
      />
      <path
        id="man-top-pants"
        data-name="Tracé 1586"
        class="dark"
        d="M798.973,447.458c0,.229-.311.3-.541.29a17.482,17.482,0,0,0-2.46-.207c-1.037.094-1.99.667-3.03.719a9.194,9.194,0,0,0-1.2.035c-.511.1-.967.406-1.487.45-.452.039-.9-.131-1.349-.113a2.168,2.168,0,0,0-.9.257,1.27,1.27,0,0,1,.37-.772c.33-.325.8-.24,1.255-.318a7.193,7.193,0,0,0,1.326-.424,13.028,13.028,0,0,1,3.744-.866,8.175,8.175,0,0,1,3.78.6,2.15,2.15,0,0,1,.488.276A.214.214,0,0,1,798.973,447.458Z"
        transform="translate(-683.034 -406.564)"
      />
      <path
        id="Tracé_1587"
        data-name="Tracé 1587"
        class="t-shirt"
        d="M775.9,332.346l-1.119-.414-.472-.174a2.285,2.285,0,0,0-.6-.16,1.533,1.533,0,0,0-1.34.779,4.208,4.208,0,0,0-.49,1.543q-.191,1.1-.323,2.2a14.383,14.383,0,0,0-.145,2.008,23.784,23.784,0,0,0,.791,5.06,17.806,17.806,0,0,1,.441,2.244c.033.312.048.626.081.939.036.352.094.7.152,1.05l.333,1.985a2.623,2.623,0,0,1,1.395-.568c.452-.017.9.152,1.349.113a15.424,15.424,0,0,0,1.487-.449,8.964,8.964,0,0,1,1.2-.035c1.039-.052,1.993-.627,3.029-.72a16.636,16.636,0,0,1,2.461.206c.229.014.54-.059.54-.29,0-.16-.16-.267-.3-.347a14.775,14.775,0,0,1-1.871-1.336,6.318,6.318,0,0,1-1.471-1.456c-.9-1.4-.592-3.3-1.362-4.777-.626-1.2,0-2.776,0-4.131a6.284,6.284,0,0,0-.529-3.092l-.537-1.36a.222.222,0,0,0-.064-.1.211.211,0,0,0-.123-.037,1.3,1.3,0,0,0-.892.286c-.253.206-.414.5-.663.715A1.009,1.009,0,0,1,775.9,332.346Z"
        transform="translate(-668.735 -307.05)"
      />
      <path
        id="man-jacket-right"
        data-name="Tracé 1588"
        class="man-jacket"
        d="M808.381,326.15a2.45,2.45,0,0,1,.436-1.068.839.839,0,0,1,1.04-.24c.37.24.385.8.7,1.1a1.7,1.7,0,0,0,1.066.32,7.23,7.23,0,0,1,1.971.464.806.806,0,0,1,.327.2c.173.2.138.5.224.742.117.315.442.515.568.829a1.653,1.653,0,0,1-.116,1.1c-.209.642-.34,1.309-.543,1.954a4.352,4.352,0,0,1-.967,1.766c-.21.215-.522.414-.8.286l-.106.767a1.3,1.3,0,0,0,0,.49.439.439,0,0,0,.32.34c.021.119.146.175.249.24a.691.691,0,0,1,.175.967c-.087.117-.215.21-.257.349a.5.5,0,0,0,.265.525c.18.11.391.162.573.268a1.782,1.782,0,0,1,.711,1.065,1.974,1.974,0,0,0,.414.885c.091.087.2.153.287.244a1.048,1.048,0,0,1,.247.634,1.258,1.258,0,0,1-.18.829,2.5,2.5,0,0,1-1.243.691,10.473,10.473,0,0,0-1.983,1.3,2.117,2.117,0,0,1-.9.425,7.922,7.922,0,0,1-1.338-.156,3.324,3.324,0,0,0-.8.105l-.829.18a5.374,5.374,0,0,0-.507-1.9,9.43,9.43,0,0,1-.354-3.591,28.139,28.139,0,0,1,.577-3.583,22.864,22.864,0,0,1,.414-2.5,16.467,16.467,0,0,0,.722-2.326C808.959,328.543,808.086,327.437,808.381,326.15Z"
        transform="translate(-699.41 -301.638)"
      />
      <path
        id="man-jacket-right-arm"
        data-name="Tracé 1589"
        class="man-jacket"
        d="M849.381,352.186a1.519,1.519,0,0,1,.159.449,1.62,1.62,0,0,0,.349.657,2.266,2.266,0,0,1,.367.414,3.1,3.1,0,0,1,.138.8,6.394,6.394,0,0,1,.3.829,1.516,1.516,0,0,0,.023.251c.09.334.581.414.69.749.073.217-.052.453-.029.681a.6.6,0,0,1,.012.215.437.437,0,0,1-.157.2,3.176,3.176,0,0,0-.909,1.617,9.213,9.213,0,0,0-.209,1.869l-.54-.714a.82.82,0,0,0-.216-.221c-.069-.041-.149-.062-.22-.1a1,1,0,0,1-.363-.583,5.385,5.385,0,0,0-.967-1.674,1.827,1.827,0,0,1-.523-.854,1.571,1.571,0,0,1,.025-.461,7.865,7.865,0,0,1,.726-2.634c.206-.376.472-.715.67-1.1C848.841,352.322,849.027,351.664,849.381,352.186Z"
        transform="translate(-734.127 -325.121)"
      />
      <path
        id="man-jacket-left-arm"
        data-name="Tracé 1590"
        class="man-jacket"
        d="M715.491,299.126a.631.631,0,0,1-.086.331.437.437,0,0,1-.436.138,1.262,1.262,0,0,1-.436-.2l-1.155-.731a6.373,6.373,0,0,1-.62-.425,5.534,5.534,0,0,1-.819-.858c-.671-.829-1.265-1.728-2.012-2.486-.2-.207-.414-.406-.61-.623a9.086,9.086,0,0,1-.737-.992,1.69,1.69,0,0,1-.4-1.054c.022-.215.126-.414.156-.628a.392.392,0,0,0-.333-.546.563.563,0,0,1-.12-.026c-.192-.08-.163-.377-.025-.533s.343-.243.468-.414a2.5,2.5,0,0,1,.2-.291.747.747,0,0,1,.322-.162,4.98,4.98,0,0,1,2.451-.093c.138.03.3.086.337.22a.4.4,0,0,1,0,.2,4.447,4.447,0,0,0-.1.829,1.467,1.467,0,0,0,.01.174,3.124,3.124,0,0,0,.815,1.539c.439.544.885,1.084,1.333,1.623a6.378,6.378,0,0,0,.808.863,4.609,4.609,0,0,1,.849.708,1.55,1.55,0,0,1,.138.848A18.825,18.825,0,0,1,715.491,299.126Z"
        transform="translate(-613.862 -271.192)"
      />
      <path
        id="man-right-arm"
        data-name="Tracé 1591"
        class="man-skin"
        d="M876.489,337.954a2.9,2.9,0,0,0,.367-.435,2.865,2.865,0,0,0,.276-.617l.8-2.272c.127-.359.254-.72.414-1.069.166-.377.362-.74.543-1.1a14.738,14.738,0,0,0,1.073-3,1.112,1.112,0,0,0,.043-.441,1.158,1.158,0,0,0-.392-.6,2.869,2.869,0,0,0-.588-.486.967.967,0,0,0-.737-.119,1.066,1.066,0,0,0-.657.829,8.658,8.658,0,0,0-.086,1.1c-.05.53-.232,1.043-.276,1.574-.023.308,0,.619-.037.925a3.38,3.38,0,0,1-.414,1.142,7.415,7.415,0,0,1-1.786,2.2,2.873,2.873,0,0,0-.536.515,1.682,1.682,0,0,0-.258.644,1.482,1.482,0,0,0,.112,1.045,1.535,1.535,0,0,0,1.07.638C875.978,338.541,876.107,338.35,876.489,337.954Z"
        transform="translate(-757.32 -304.258)"
      />
      <path
        id="man-hair"
        data-name="Tracé 1592"
        class="hair"
        d="M792.01,268.912a1.289,1.289,0,0,1,1.251-.678,1.381,1.381,0,0,1,1.086.975,2.522,2.522,0,0,0,.2.61c.171.267.489.344.726.537a1.454,1.454,0,0,1,.464,1.028,3.109,3.109,0,0,1-.184,1.162,3.7,3.7,0,0,0-.138.486c-.028.16-.03.323-.055.483a1.574,1.574,0,0,1-.634,1.045.276.276,0,0,1-.171.062c-.108-.012-.174-.138-.214-.251-.22-.634-.167-1.409-.572-1.914a2.093,2.093,0,0,0-.655-.487.843.843,0,0,0-.334-.126.88.88,0,0,0-.483.177,3.008,3.008,0,0,1-.956.423,1.174,1.174,0,0,1-.987-.213c-.191-.157-.33-.394-.541-.517a4.168,4.168,0,0,0-.641-.2.949.949,0,0,1-.384-1.447c.138-.166.343-.26.465-.443a2.8,2.8,0,0,0,.221-.848,1.167,1.167,0,0,1,.7-.8.987.987,0,0,1,.983.206c.138.124.249.285.384.414a1.105,1.105,0,0,0,1.022.276"
        transform="translate(-683.55 -252.662)"
      />
      <path
        id="man-jacket-right-pocket"
        data-name="Tracé 1593"
        class="dark"
        d="M828.62,419.193a.536.536,0,0,0-.146.586,12.929,12.929,0,0,0,1.606-.231c.376-.054,1.034-.028,1.287-.372.45-.609-.945-.474-1.2-.452A2.632,2.632,0,0,0,828.62,419.193Z"
        transform="translate(-717.889 -382.615)"
      />
      <path
        id="man-jacket-left-sleeve"
        data-name="Tracé 1594"
        class="primaire"
        d="M711.687,289.954a4.446,4.446,0,0,0-.1.829,2.414,2.414,0,0,1-1.243-.192L709.2,290.2a.325.325,0,0,0-.436.082,9.672,9.672,0,0,1-.691.767.567.567,0,0,1-.12-.026c-.192-.08-.163-.377-.025-.533s.343-.243.468-.414a2.5,2.5,0,0,1,.2-.291.748.748,0,0,1,.322-.162,4.981,4.981,0,0,1,2.451-.093c.138.03.3.086.337.22A.4.4,0,0,1,711.687,289.954Z"
        transform="translate(-613.922 -271.192)"
      />
      <path
        id="man-jacket-left-sleeve"
        data-name="Tracé 1595"
        class="primaire"
        d="M711.687,289.954a4.446,4.446,0,0,0-.1.829,2.414,2.414,0,0,1-1.243-.192L709.2,290.2a.325.325,0,0,0-.436.082,9.672,9.672,0,0,1-.691.767.567.567,0,0,1-.12-.026c-.192-.08-.163-.377-.025-.533s.343-.243.468-.414a2.5,2.5,0,0,1,.2-.291.748.748,0,0,1,.322-.162,4.981,4.981,0,0,1,2.451-.093c.138.03.3.086.337.22A.4.4,0,0,1,711.687,289.954Z"
        transform="translate(-613.922 -271.192)"
      />
      <path
        id="man-pants-line"
        data-name="Tracé 1596"
        class="dark"
        d="M794.422,479.765a.689.689,0,0,1,.482.362l-1.6-.406-.829-.211c-.146-.037-.671-.08-.768-.195-.138-.168.352-.052.441-.04.268.04.536.081.8.13C793.454,479.495,793.937,479.642,794.422,479.765Z"
        transform="translate(-686.209 -434.783)"
      />
      <path
        id="man-pants-line"
        data-name="Tracé 1597"
        class="dark"
        d="M795.165,486.439a2.99,2.99,0,0,0-.7-.122c-.249-.059-.493-.138-.738-.214-.5-.162-.987-.345-1.5-.464-.094-.021-.414-.026-.4-.145s.32-.16.4-.166a3.916,3.916,0,0,1,1.435.329A6.325,6.325,0,0,1,795.165,486.439Z"
        transform="translate(-686.332 -440.041)"
      />
      <path
        id="man-pants-line"
        data-name="Tracé 1598"
        class="dark"
        d="M796.231,468.681a10.6,10.6,0,0,0-1.489-.514.6.6,0,0,1-.38-.116.447.447,0,0,1-.123-.221,2.574,2.574,0,0,1,1.073.269,3.38,3.38,0,0,1,.5.268C795.932,468.438,796.106,468.641,796.231,468.681Z"
        transform="translate(-688.412 -424.962)"
      />
      <path
        id="man-right-sleeve"
        data-name="Tracé 1599"
        class="primaire"
        d="M867.937,384.46a2.416,2.416,0,0,0,1.693,2.67c-.068.327-.406.508-.645.742-.337.327-.511.818-.909,1.066a2.027,2.027,0,0,1-1.519.052.185.185,0,0,1-.119-.062.171.171,0,0,1-.022-.054,3.554,3.554,0,0,1-.1-1.878,6.135,6.135,0,0,1,.735-1.428C867.311,385.106,867.336,384.612,867.937,384.46Z"
        transform="translate(-750.455 -353.106)"
      />
      <path
        id="man-jacket-top-left"
        data-name="Tracé 1600"
        class="man-jacket"
        d="M749.032,327.092a3.592,3.592,0,0,0-1.519.463,1.7,1.7,0,0,1-.981.372c-.209-.023-.414-.138-.617-.083a1.211,1.211,0,0,0-.316.188.358.358,0,0,1-.348.055L745.113,330a7.01,7.01,0,0,0,.07,2.177,6.1,6.1,0,0,1,.309,1.058c.022.367-.011.744.015,1.116.025.344.1.682.12,1.026a6.529,6.529,0,0,1-.276,1.924,11.452,11.452,0,0,1-.829,2.725,1.607,1.607,0,0,0-.276.736.376.376,0,0,0,.008.1c-.138.076-.267.148-.384.222a1.472,1.472,0,0,0-.65.653c-.087.239-.047.512-.152.743s-.345.395-.4.644c-.037.181.034.372,0,.552a2.371,2.371,0,0,0-.076.286.6.6,0,0,0,.336.487,2.7,2.7,0,0,0,.829.365l.825-3.273h0a26.394,26.394,0,0,0,1.869-4.346,9.343,9.343,0,0,1,.54-1.431,6.727,6.727,0,0,0,.414-.812,6.12,6.12,0,0,0,.2-1.092,7.65,7.65,0,0,1,.325-1.261,5.412,5.412,0,0,0,.352-1.351,6.216,6.216,0,0,1,.061-1.985,2.639,2.639,0,0,1,.421-.634c.356-.436.681-.894,1.037-1.33A.958.958,0,0,0,749.032,327.092Z"
        transform="translate(-643.899 -303.657)"
      />
      <g
        id="man-hair-shadow"
        data-name="Groupe 560"
        class="dark"
        transform="translate(105.053 15.796)"
      >
        <path
          id="Tracé_1601"
          data-name="Tracé 1601"
          d="M816.192,271.81l-.173.012-.019.014A1.021,1.021,0,0,0,816.192,271.81Z"
          transform="translate(-812.22 -271.81)"
        />
        <path
          id="Tracé_1602"
          data-name="Tracé 1602"
          d="M795.763,286.994a3.722,3.722,0,0,1-.177.807,3.672,3.672,0,0,0-.138.486c-.028.16-.031.323-.055.483a1.575,1.575,0,0,1-.634,1.046.277.277,0,0,1-.171.062c-.108-.012-.174-.138-.214-.251-.219-.634-.167-1.409-.572-1.914a2.092,2.092,0,0,0-.655-.488.845.845,0,0,0-.334-.126.88.88,0,0,0-.483.177,3.009,3.009,0,0,1-.956.423,1.174,1.174,0,0,1-.987-.213c-.191-.157-.33-.394-.541-.516a4.164,4.164,0,0,0-.641-.2.943.943,0,0,1-.539-.616.406.406,0,0,1-.011-.052.967.967,0,0,0,.011.467.943.943,0,0,0,.539.616,4.655,4.655,0,0,1,.641.2,5.216,5.216,0,0,1,.541.517,1.174,1.174,0,0,0,.987.213,3.011,3.011,0,0,0,.956-.423.88.88,0,0,1,.483-.177.845.845,0,0,1,.334.126,2.091,2.091,0,0,1,.645.492c.4.505.352,1.28.572,1.914.04.115.106.239.214.251a.276.276,0,0,0,.181-.066,1.575,1.575,0,0,0,.635-1.05c.025-.16.028-.323.055-.483a3.691,3.691,0,0,1,.138-.486,3.11,3.11,0,0,0,.184-1.161C795.768,287.032,795.766,287.013,795.763,286.994Z"
          transform="translate(-788.631 -284.126)"
        />
      </g>
      <path
        id="trophy-right-arm"
        data-name="Tracé 1603"
        class="primaire"
        d="M657.645,372.81l-.094,1.261a26.221,26.221,0,0,1-2.755,9.013,25.577,25.577,0,0,1-13.714,12.4q-.891.352-1.849.657l-.713-2.237a26.164,26.164,0,0,0,5.14-2.248,22.75,22.75,0,0,0,9-9.552,25.657,25.657,0,0,0,2.362-6.947h-8.659V372.81Z"
        transform="translate(-554.199 -343.065)"
      />
      <path
        id="trophy-right-arm"
        data-name="Tracé 1604"
        class="primaire"
        d="M644.218,395.5a25.572,25.572,0,0,0,13.713-12.4,26.17,26.17,0,0,0,2.755-9.013l.094-1.261h.967l-.094,1.261A26.185,26.185,0,0,1,658.9,383.1a25.577,25.577,0,0,1-13.713,12.4q-.891.352-1.851.659l-.094-.294Q643.74,395.69,644.218,395.5Z"
        transform="translate(-558.267 -343.083)"
      />
      <path
        id="trophy-left-arm"
        data-name="Tracé 1605"
        class="primaire"
        d="M420.645,393.9l-.713,2.237q-.96-.307-1.851-.659a25.571,25.571,0,0,1-13.713-12.4,26.169,26.169,0,0,1-2.755-9.013l-.094-1.261H412.8v2.348h-8.661a25.673,25.673,0,0,0,2.369,6.947,22.736,22.736,0,0,0,9,9.55,26.1,26.1,0,0,0,5.142,2.25Z"
        transform="translate(-349.931 -343.065)"
      />
      <path
        id="trophy-left-arm"
        data-name="Tracé 1606"
        class="dark"
        d="M418.789,395.5a25.571,25.571,0,0,1-13.713-12.4,26.169,26.169,0,0,1-2.755-9.013l-.094-1.261h-.967l.094,1.261a26.185,26.185,0,0,0,2.755,9.013,25.576,25.576,0,0,0,13.713,12.4q.891.352,1.851.659l.094-.294Q419.268,395.69,418.789,395.5Z"
        transform="translate(-349.706 -343.083)"
      />
      <path
        id="trophy-bottom"
        data-name="Tracé 1607"
        class="primaire"
        d="M520.977,580.447v12.66H494.92v-12.66l.829-1.1c8.444-3,10.155-10.813,10.5-13.9a12.7,12.7,0,0,0,.087-1.287h3.222a12.718,12.718,0,0,0,.087,1.287c.347,3.092,2.058,10.911,10.5,13.9Z"
        transform="translate(-430.431 -507.98)"
      />
      <rect
        id="trophy-shadow"
        data-name="Rectangle 758"
        class="dark"
        width="26.057"
        height="1.588"
        transform="translate(64.489 72.467)"
      />
      <path
        id="Tracé_1608"
        data-name="Tracé 1608"
        class="cls-11"
        d="M497.13,579.342c8.444-3,10.155-10.813,10.5-13.9a12.709,12.709,0,0,0,.087-1.287h-1.381a12.719,12.719,0,0,1-.087,1.287c-.347,3.092-2.058,10.911-10.5,13.9l-.829,1.1v12.66H496.3v-12.66Z"
        transform="translate(-430.431 -507.98)"
      />
      <path
        id="Tracé_1609"
        data-name="Tracé 1609"
        class="cls-7"
        d="M466.26,372.81H468.6v2.348h-2.13Q466.341,374,466.26,372.81Z"
        transform="translate(-405.729 -343.065)"
      />
      <path
        id="Tracé_1610"
        data-name="Tracé 1610"
        class="cls-7"
        d="M507.912,511.51l-.713,2.237q-.96-.307-1.851-.659a24.744,24.744,0,0,1-2.578-3.828,26.1,26.1,0,0,0,5.142,2.25Z"
        transform="translate(-437.197 -460.67)"
      />
      <path
        id="Tracé_1611"
        data-name="Tracé 1611"
        class="cls-7"
        d="M638.51,511.518a26.162,26.162,0,0,0,5.14-2.248,24.841,24.841,0,0,1-2.578,3.83q-.891.352-1.849.657Z"
        transform="translate(-554.19 -460.679)"
      />
      <path
        id="Tracé_1612"
        data-name="Tracé 1612"
        class="cls-7"
        d="M697.665,372.81q-.081,1.188-.207,2.348H695.33V372.81Z"
        transform="translate(-603.163 -343.065)"
      />
      <path
        id="Tracé_1613"
        data-name="Tracé 1613"
        class="cls-7"
        d="M580.356,565.437a8.928,8.928,0,0,1-3.4,0,12.711,12.711,0,0,0,.087-1.287h3.222A12.711,12.711,0,0,0,580.356,565.437Z"
        transform="translate(-501.141 -507.98)"
      />
      <path
        id="trophy"
        data-name="Tracé 1614"
        class="primaire"
        d="M468.26,344.65c.059,17.41,7.517,31.489,16.711,31.489s16.65-14.079,16.711-31.489Z"
        transform="translate(-407.453 -318.795)"
      />
      <path
        id="Tracé_1615"
        data-name="Tracé 1615"
        class="cls-11"
        d="M471.229,344.65H468.26c.059,17.41,7.517,31.489,16.711,31.489a9.024,9.024,0,0,0,1.485-.126C477.957,374.593,471.286,361.113,471.229,344.65Z"
        transform="translate(-407.453 -318.795)"
      />
      <rect
        id="trophy-plaque"
        data-name="Rectangle 759"
        class="secondaire"
        width="17.724"
        height="4.558"
        transform="translate(68.656 77.314)"
      />
      <path
        id="Tracé_1616"
        data-name="Tracé 1616"
        class="cls-11"
        d="M497.919,594.121h16.895V593.5H497.09v4.558h.829Z"
        transform="translate(-428.434 -516.186)"
      />
      <path
        id="Tracé_1617"
        data-name="Tracé 1617"
        class="cls-12"
        d="M209.137,324.245c-.319-.106-2.2-1.592-2.34-2.265a69.08,69.08,0,0,1,.993-6.939,2.554,2.554,0,0,1-.276-.021v-.1l.233-8.231s.957-5.524-.851-5.2-.674,5.2-.674,5.2-.206,2.478-.351,3.221c-.138.717-.771,3.636-.34,4.544a1,1,0,0,0,.052.094h0s.072,3.114-.708,3.54c-.744.4-1.054,2.442-1.08,2.624l-.04-.017h0a2.164,2.164,0,0,1-.576-.526c-.017-.021-.029-.043-.044-.065a3.042,3.042,0,0,0-.936-4.75,1.961,1.961,0,0,0-.184-.762c-.359-.768-2.348-1.772-3.761-1.8-.652-.019-1.186.166-1.381.675a3.9,3.9,0,0,0-.11.82,2.086,2.086,0,0,1-.894,1.329,5.6,5.6,0,0,0-.6-.573,13.007,13.007,0,0,1-1.381-1.519s-2.871-2.973-3.084-3.788-3.081-5.708-3.719-4.856,2.2,4.566,2.2,4.566a8.639,8.639,0,0,0,.953,1.805c.414.456,3.591,5.069,3.591,5.069l.152.315a2.76,2.76,0,0,0-1.5,1.505c-.318,1.033.377,2.072.858,3.038a6.021,6.021,0,0,1-.138,6.016c-1.083,1.522-2.961,2.246-4.719,2.878a4.644,4.644,0,0,0,2.983.99c-.406,1.177-1.845,1.566-3.072,1.784a4.421,4.421,0,0,0,2.449.981,7.336,7.336,0,0,0,1.311.1h.108l.108-.008a3.755,3.755,0,0,0,.446-.057,2.344,2.344,0,0,0,1.584-1.041c.276-.482.373-1.139.874-1.381a1.117,1.117,0,0,1,.414-.1h.269l2.09.021h.267a1.727,1.727,0,0,0,1.519-.6,1.674,1.674,0,0,0,.189-.767c.044-.662,0-1.342.018-2.01.178,1.214.365,3.106-.079,3.8a6.491,6.491,0,0,1-1.3,1.4,2.486,2.486,0,0,0-.343.351c-.068.048-.108.075-.108.075l-.043.128a2.432,2.432,0,0,0-.337.782.543.543,0,0,0-.026.222c.048.1-.345.5-.231.673a6.092,6.092,0,0,0-1.17,2.9l-1.8,2.726c-.923,2.424-2.3,2.672-2.3,2.672s-3.244-2.177-3.333-2.283a12.53,12.53,0,0,0-1.329-.638,1.406,1.406,0,0,0-.638-.583c-.425-.177-.461-.829-.461-.829-.052-1.54-.957-1.657-.957-1.657a2.939,2.939,0,0,0-1.714.305l-.13.01c-.627.051-1.381.108-2.21.163a3.048,3.048,0,0,0-2.853,1.645.46.46,0,0,0,.088.664c.372.345,2.75,0,2.851-.008a1.544,1.544,0,0,1-.541-.037c.374-.014.889-.028,1.329-.028h.106a5.749,5.749,0,0,0-.04.7c0,.442,1.222.725,1.222.725l3.722,3.315a14.744,14.744,0,0,1,3.828,2.549,1.91,1.91,0,0,0,2.8.206c1.576-.389,6.11-5.871,6.114-5.877h0c0,.16.1,5.491.276,6.562h0a.712.712,0,0,0,.04.159,5.222,5.222,0,0,1-.195,2.247,6.244,6.244,0,0,0-.09,1.345s-1.7,6.491-1.559,7.061-.921,3.221-.921,3.221v2.21l.185-.01a1.193,1.193,0,0,0-.066.111l-.012.023a7.86,7.86,0,0,0,1.9.177,5.319,5.319,0,0,1,2.072.587,5.768,5.768,0,0,0,1.808.3c1.365.088,1.365-.6,1.365-.6-.156-.941-2.312-1.255-2.378-1.265-.174-.109-.337-.228-.471-.33l-.028-.022a.587.587,0,0,0,.023-.064c.231-.939-1.045-1.347-1.045-1.347v-.229c.829-.425.993-3.345.993-3.345s1.243-3.61,1.417-4.212a3.981,3.981,0,0,0,0-1.5l.124-.779a3.831,3.831,0,0,0,.267-.637,1.573,1.573,0,0,1,.3-.743c.195-.231-.213-.779-.213-.779l.355-.92v-1.01l.829-3.663s.869-4.266.568-5.663a2.4,2.4,0,0,1,.355-2.106,1.744,1.744,0,0,1-.182.083,5.276,5.276,0,0,0,.214-.588l1.864.231v.028h.673s-.213-2.624-.213-3.682.717-4.855.717-4.855S209.457,324.351,209.137,324.245Zm-8.277-3.063c0,.1-.01.211-.017.322l-.037.057-.069-.058-.084.131-.025.012c-.182-.094-.276-.631-.407-.515l-.018.015c-.029-.033-.058-.043-.088-.015l-.028.023v-.123a3.108,3.108,0,0,0,.773.1C200.862,321.147,200.861,321.165,200.861,321.181Zm6.2,12.22h.04l-.066.174C207.044,333.517,207.052,333.461,207.062,333.4Zm-6.807,31.319-.254-.064.138-.023.128.084.015.011Zm2.6-.372c-.084-.044-.17-.1-.253-.148C202.626,364.216,202.735,364.273,202.851,364.349Z"
        transform="translate(-157.783 -281.58)"
      />
      <path
        id="Tracé_1618"
        data-name="Tracé 1618"
        class="secondaire"
        d="M345.71,390.03l-1.673,4.359h.406l-1.573,1.254,2.84.354Z"
        transform="translate(-295.514 -340.818)"
      />
      <path
        id="Tracé_1620"
        data-name="Tracé 1620"
        class="secondaire"
        d="M344.44,360.791h2.623l.963-7.921H344.44Z"
        transform="translate(-296.867 -308.79)"
      />
      <path
        id="Tracé_1622"
        data-name="Tracé 1622"
        class="woman-skin"
        d="M333.684,436.143l.566-.1,1.3-.221s3.907-.881,4.714-.953a5.037,5.037,0,0,0,1.414-.4c.211-.091.345-.16.345-.16l-1.407-2.57-2.184-1.619a3.78,3.78,0,0,1-1.965-1.1,1.294,1.294,0,0,1-.181-1.226c.356-1.1-2.128,1.057-2.128,1.057s.023.518,0,1.178c0,.13-.012.265-.022.4a2.717,2.717,0,0,1-.022.276,4.442,4.442,0,0,1-.431,1.735C333.083,433.432,333.684,436.143,333.684,436.143Z"
        transform="translate(-291.233 -390.188)"
      />
      <path
        id="woman-neck-shadow"
        data-name="Tracé 1623"
        class="dark"
        d="M338.79,430.431h.055c.1,0,.18-.211.276-.221a2.865,2.865,0,0,0,1.981-.789,1.3,1.3,0,0,1-.181-1.225c.356-1.1-2.128,1.055-2.128,1.055S338.819,429.771,338.79,430.431Z"
        transform="translate(-295.864 -390.531)"
      />
      <path
        id="woman-face"
        data-name="Tracé 1624"
        class="woman-skin"
        d="M316.89,404.771a3.026,3.026,0,0,0,3.027,3.027,2.111,2.111,0,0,0,.3-.014,3.027,3.027,0,1,0-3.323-3.014Z"
        transform="translate(-276.989 -368.004)"
      />
      <path
        id="woman-hair"
        data-name="Tracé 1625"
        class="hair"
        d="M257.6,386.186a3.723,3.723,0,0,0-.109.816c-.148.982-1.146,1.57-2.05,1.982s-1.922.9-2.21,1.848c-.315,1.026.373,2.055.851,3.018a5.99,5.99,0,0,1-.138,5.983c-1.068,1.519-2.928,2.24-4.679,2.873a4.613,4.613,0,0,0,2.962.986c-.4,1.17-1.831,1.558-3.049,1.773a4.381,4.381,0,0,0,2.432.975,5.515,5.515,0,0,0,1.934.036,2.323,2.323,0,0,0,1.572-1.036c.276-.479.37-1.132.869-1.374a1.572,1.572,0,0,1,.708-.1l2.072.022c.645,0,1.409-.05,1.742-.6a1.657,1.657,0,0,0,.188-.762c.09-1.359-.171-2.8.388-4.036.169-.374-.913-.967-.8-1.363a12.733,12.733,0,0,0,.483-3.855,5.875,5.875,0,0,1,1.3-2.971,3.354,3.354,0,0,0,.617-3.091C262.164,386.2,258.222,384.586,257.6,386.186Z"
        transform="translate(-218.63 -354.014)"
      />
      <path
        id="woman-right-foot"
        data-name="Tracé 1626"
        class="woman-skin"
        d="M330.13,752.172l.528.349.081.054.015.01.626.414,1.461.246,1.284-.088s.37-.773-.211-.755a1.209,1.209,0,0,1-.53-.153l-.08-.04h0c-.084-.044-.169-.094-.251-.146h0c-.173-.109-.336-.228-.467-.329-.193-.149-.322-.262-.322-.262Z"
        transform="translate(-288.4 -669.429)"
      />
      <path
        id="Tracé_1627"
        data-name="Tracé 1627"
        class="cls-7"
        d="M334,757.373l.081.054.015.01.626.414,1.461.246,1.284-.088s.37-.773-.211-.755a1.209,1.209,0,0,1-.53-.153c.1.08.188.167.2.24.023.2-.95.552-.95.552l-1.373-.363s-.233-.066-.552-.149l-.03-.008Z"
        transform="translate(-291.736 -674.281)"
      />
      <path
        id="woman-right-shoe"
        data-name="Tracé 1628"
        class="shoes"
        d="M317,756.5a7.778,7.778,0,0,0,1.882.175,5.3,5.3,0,0,1,2.061.581,5.776,5.776,0,0,0,1.8.3c1.355.088,1.355-.6,1.355-.6-.155-.935-2.3-1.243-2.362-1.257h0a2.629,2.629,0,0,1,.251.146h0c.152.1.316.229.329.334.023.2-.95.552-.95.552l-1.373-.362s-.233-.068-.552-.151h-.03a11.772,11.772,0,0,0-1.439-.3,1,1,0,0,0-.956.552A.162.162,0,0,0,317,756.5Z"
        transform="translate(-277.084 -673.075)"
      />
      <path
        id="woman-left-foot"
        data-name="Tracé 1629"
        class="woman-skin"
        d="M188.54,571.839l.6.458s.174-.008.434-.017h.083c.372-.014.884-.028,1.319-.028a4.189,4.189,0,0,1,.841.047c.3.1.829-1.707.829-1.707l-.6-.138-.2-.047-.138-.033-.488-.115-1.478.169-1.039.668Z"
        transform="translate(-166.365 -513.246)"
      />
      <path
        id="Tracé_1630"
        data-name="Tracé 1630"
        class="cls-7"
        d="M188.54,571.839l.6.459s.174-.008.434-.017a.524.524,0,0,1-.276-.247c-.387-1.073,1.532-1.532,1.532-1.532l.894-.039.174-.008h.138l-.2-.047-.138-.033-.488-.115-1.478.168-1.039.668Z"
        transform="translate(-166.365 -513.246)"
      />
      <path
        id="woman-left-shoe"
        data-name="Tracé 1631"
        class="shoes"
        d="M178.806,568.893c.362.334,2.732,0,2.831-.008a1.492,1.492,0,0,1-.537-.037.592.592,0,0,1-.414-.3c-.387-1.074,1.532-1.532,1.532-1.532l.894-.039.173-.008,2.172-.094.1-.6s-.706.066-1.813.155c-.623.051-1.381.108-2.2.162a3.027,3.027,0,0,0-2.833,1.637A.459.459,0,0,0,178.806,568.893Z"
        transform="translate(-157.81 -509.815)"
      />
      <path
        id="woman-right-arm"
        data-name="Tracé 1632"
        class="woman-skin"
        d="M371.529,316.909a.61.61,0,0,0,.052.094l.528.773,1.373.138.015-.544.231-8.187s.95-5.491-.845-5.175-.668,5.175-.668,5.175-.2,2.464-.348,3.2C371.726,313.1,371.1,316.011,371.529,316.909Z"
        transform="translate(-323.954 -283.754)"
      />
      <path
        id="woman-belly"
        data-name="Tracé 1633"
        class="woman-skin"
        d="M350.14,541.292l.391.668.874,1.5s1.585.581,1.992.138a5.737,5.737,0,0,0,.631-1.8c.138-.575.231-1.059.231-1.059Z"
        transform="translate(-305.647 -487.803)"
      />
      <path
        id="Tracé_1634"
        data-name="Tracé 1634"
        class="cls-7"
        d="M350.14,541.336l.391.668a.456.456,0,0,0,.066-.07c.442-.563,2.388-.12,3.431-.084.138-.575.231-1.059.231-1.059Z"
        transform="translate(-305.647 -487.846)"
      />
      <path
        id="Tracé_1635"
        data-name="Tracé 1635"
        class="cls-7"
        d="M206.16,568.82a4.189,4.189,0,0,1,.841.047c.3.1.829-1.707.829-1.707l-.8-.188,2.172-.094.1-.6s-.706.066-1.813.155a2.278,2.278,0,0,0-.6.5l-.033.041A3.62,3.62,0,0,0,206.16,568.82Z"
        transform="translate(-181.552 -509.815)"
      />
      <path
        id="Tracé_1636"
        data-name="Tracé 1636"
        class="cls-7"
        d="M330.13,752.137l.609.4c.909-.164,1.739-.423,1.837-.829a.146.146,0,0,0,0-.019c-.193-.149-.322-.262-.322-.262Z"
        transform="translate(-288.4 -669.394)"
      />
      <path
        id="Tracé_1637"
        data-name="Tracé 1637"
        class="cls-7"
        d="M317.09,757.842a21.074,21.074,0,0,0,2.395-.257,11.764,11.764,0,0,0-1.44-.3A.994.994,0,0,0,317.09,757.842Z"
        transform="translate(-277.161 -674.436)"
      />
      <path
        id="woman-pants"
        data-name="Tracé 1638"
        class="primaire"
        d="M206.64,547.494c0,.441,1.214.722,1.214.722l3.7,3.291a14.609,14.609,0,0,1,3.8,2.534,1.893,1.893,0,0,0,2.782.211c1.566-.387,6.077-5.843,6.077-5.843s.1,6.232.316,6.689a5.194,5.194,0,0,1-.193,2.236,6.215,6.215,0,0,0-.088,1.337s-1.689,6.459-1.548,7.023-.916,3.2-.916,3.2v2.2s4.136-.159,4.364-1.091-1.037-1.338-1.037-1.338v-.229c.829-.423.985-3.326.985-3.326s1.233-3.591,1.409-4.189a3.916,3.916,0,0,0,0-1.5l.123-.773a3.863,3.863,0,0,0,.264-.634,1.566,1.566,0,0,1,.3-.739c.193-.229-.211-.775-.211-.775l.352-.916v-1l.829-3.643s.863-4.243.563-5.633a2.384,2.384,0,0,1,.352-2.094c-1.413.74-2.125-.907-2.359-1.616-.059-.182-.088-.3-.088-.3a9.88,9.88,0,0,0-3.747-.544,4.311,4.311,0,0,0-1.076.228c-2.007.722-2.323,3.714-2.323,3.714l-1.777,2.711c-.916,2.411-2.288,2.657-2.288,2.657s-3.221-2.164-3.315-2.271a12.9,12.9,0,0,0-1.32-.634,1.4,1.4,0,0,0-.634-.58c-.423-.177-.457-.829-.457-.829-.052-1.532-.95-1.657-.95-1.657C206.622,543.834,206.64,547.055,206.64,547.494Z"
        transform="translate(-181.965 -487.792)"
      />
      <rect
        id="woman-jacket-left"
        data-name="Rectangle 760"
        class="secondaire"
        width="1.9"
        height="5.896"
        transform="translate(44.493 51.096) rotate(180)"
      />
      <path
        id="Tracé_1639"
        data-name="Tracé 1639"
        class="cls-7"
        d="M372.439,397.41a.084.084,0,0,0,0,.012.614.614,0,0,0,.052.094l.528.773,1.373.138.015-.544A5.482,5.482,0,0,1,372.439,397.41Z"
        transform="translate(-324.865 -364.268)"
      />
      <path
        id="woman-jacket-right"
        data-name="Tracé 1640"
        class="secondaire"
        d="M361.72,398.18s.07,3.1-.7,3.519-1.076,2.624-1.076,2.624a19.73,19.73,0,0,1,2.871,2.224c.523.68,1.725,2.3,1.478,2.685s.6,2.148.6,2.148-1.55,3.168-1.2,4.366a25.01,25.01,0,0,1,.387,4.364h.67s-.211-2.6-.211-3.661.7-4.823.7-4.823.318-3.7,0-3.8-2.182-1.584-2.323-2.254a68.983,68.983,0,0,1,.986-6.905A6.164,6.164,0,0,1,361.72,398.18Z"
        transform="translate(-314.093 -364.932)"
      />
      <path
        id="Tracé_1641"
        data-name="Tracé 1641"
        class="cls-7"
        d="M336.12,447.724a3.014,3.014,0,0,0,.46,1.207l1.3-.221s3.907-.881,4.714-.953a5.038,5.038,0,0,0,1.414-.4,6.237,6.237,0,0,0-1.747-2.866l-.5-.46a8.307,8.307,0,0,0-2.5-1.6c.058.048,4.157,3.548,3.259,4.234s-3.315-.985-3.315-.985l-2.748-2.362-.1-.086-.159.247a2.306,2.306,0,0,1,.236.113,4.044,4.044,0,0,1,1.934,2.4C338.939,447.895,336.12,447.724,336.12,447.724Z"
        transform="translate(-293.563 -403.07)"
      />
      <path
        id="Tracé_1642"
        data-name="Tracé 1642"
        class="cls-15"
        d="M330,541.255s2.6,1.443,3.237.634a1.077,1.077,0,0,1,.793-.276c-.059-.182-.088-.3-.088-.3a9.88,9.88,0,0,0-3.747-.544Z"
        transform="translate(-288.288 -487.801)"
      />
      <path
        id="woman-t-shirt"
        data-name="Tracé 1643"
        class="t-shirt"
        d="M331.2,443.261l2.848,2.45s2.407,1.677,3.315.985-3.261-4.236-3.261-4.236h0a8.424,8.424,0,0,1,2.5,1.594l.5.46c1.3,1.208,1.6,1.208,1.642,2.984a2.5,2.5,0,0,1-.253,1.18c-.423.414-.718,3.424-.653,3.776s-.787,3.392-.511,4.237-3.453-.423-4.084.388-3.236-.634-3.236-.634a28.543,28.543,0,0,1,1.8-3.943,2.865,2.865,0,0,0,0-3.027,3.284,3.284,0,0,1-.844-1.725s2.817.174,2.253-1.725a3.986,3.986,0,0,0-2.166-2.516Z"
        transform="translate(-288.288 -403.096)"
      />
      <path
        id="Tracé_1644"
        data-name="Tracé 1644"
        class="cls-7"
        d="M347.752,493.38a6.321,6.321,0,0,1-2.505,2.594c-.046.017-.09.032-.138.046C343.634,496.468,347.863,494.018,347.752,493.38Z"
        transform="translate(-301.041 -446.984)"
      />
      <path
        id="woman-left-arm"
        data-name="Tracé 1645"
        class="woman-skin"
        d="M241.367,332.542a8.222,8.222,0,0,0,.95,1.8c.423.457,3.555,5.034,3.555,5.034l.265.552.228.471,2.007-.211.138-.809-.077-.094a9.481,9.481,0,0,0-1.12-1.174,12.975,12.975,0,0,1-1.373-1.512s-2.851-2.958-3.062-3.768-3.063-5.663-3.7-4.823S241.367,332.542,241.367,332.542Z"
        transform="translate(-209.934 -304.363)"
      />
      <g
        id="Groupe_561"
        data-name="Groupe 561"
        class="cls-9"
        transform="translate(33.726 31.5)"
      >
        <path
          id="Tracé_1646"
          data-name="Tracé 1646"
          d="M275.71,519.063a1.574,1.574,0,0,0-.708.1c-.5.242-.591.895-.867,1.374a2.323,2.323,0,0,1-1.573,1.036,3.531,3.531,0,0,1-.381.052,4.328,4.328,0,0,0,1.21-.052,2.323,2.323,0,0,0,1.573-1.036c.276-.479.37-1.133.867-1.374a1.1,1.1,0,0,1,.414-.1Z"
          transform="translate(-272.18 -500.615)"
        />
        <path
          id="Tracé_1647"
          data-name="Tracé 1647"
          d="M317.763,393.375a5.884,5.884,0,0,1,1.3-2.971,3.357,3.357,0,0,0,.617-3.091c-.4-.849-2.8-1.989-4.179-1.764,1.355.175,3.025,1.068,3.351,1.764a3.357,3.357,0,0,1-.617,3.091,5.861,5.861,0,0,0-1.3,2.971,12.893,12.893,0,0,1-.485,3.855c-.112.394.967.989.8,1.362-.561,1.243-.3,2.677-.388,4.036a1.678,1.678,0,0,1-.189.762,1.615,1.615,0,0,1-1.394.6h.482c.644,0,1.407-.05,1.74-.6a1.678,1.678,0,0,0,.189-.762c.09-1.359-.173-2.794.388-4.036.168-.373-.913-.967-.8-1.362A12.739,12.739,0,0,0,317.763,393.375Z"
          transform="translate(-309.327 -385.521)"
        />
      </g>
      <path
        id="Tracé_1648"
        data-name="Tracé 1648"
        class="cls-7"
        d="M290.12,410.884l.228.471,2.007-.211.138-.809-.077-.094C292.2,410.345,290.6,411.117,290.12,410.884Z"
        transform="translate(-253.916 -375.326)"
      />
      <path
        id="Tracé_1649"
        data-name="Tracé 1649"
        class="cls-7"
        d="M298.245,416.763s-.493-.773-.775-.563-.391-.634-.552-.493-.633.533-.829-.015c-.153-.436-1.822-3.2-2.5-4.308-.174-.287-.283-.464-.283-.464s-1.9.95-2.358.634v.668l.387.036,2.072,3.867s.652,1.037.608,1.4a6.234,6.234,0,0,0,.976,2.051c.141.1,1.657,1.866,1.657,1.866s.775,3.8.1,4.859a7.208,7.208,0,0,1-1.83,1.83,5.907,5.907,0,0,0-.3,1.127c.051.106-.406.564-.195.7s.493,1.126.493,1.126.986-1.584,1.519-1.83,1.215-3.486,1.215-3.486.195-1.909.21-3.141S297.822,416.763,298.245,416.763Z"
        transform="translate(-254.631 -375.912)"
      />
      <path
        id="woman-jacket-left"
        data-name="Tracé 1650"
        class="secondaire"
        d="M297.475,416.763s-.492-.773-.773-.563-.392-.634-.552-.493-.631.533-.829-.015c-.155-.436-1.823-3.2-2.5-4.308l-.283-.464s-1.9.95-2.359.634v.668l.388.036,2.072,3.867s.653,1.037.608,1.4a6.073,6.073,0,0,0,.976,2.051c.148.1,1.657,1.866,1.657,1.866s.775,3.8.106,4.859a6.475,6.475,0,0,1-1.275,1.411,2.464,2.464,0,0,0-.829,1.329.525.525,0,0,0-.025.221c.051.1-.406.563-.195.7s.5,1.13.5,1.13.986-1.584,1.519-1.83,1.217-3.486,1.217-3.486.193-1.909.21-3.141S297.061,416.763,297.475,416.763Z"
        transform="translate(-253.968 -375.912)"
      />
      <path
        id="Tracé_1651"
        data-name="Tracé 1651"
        class="cls-7"
        d="M306.951,569.21a7.081,7.081,0,0,1,2.072.7c.592.427-2.253-.668-2.253-.668Z"
        transform="translate(-268.266 -512.341)"
      />
      <path
        id="Tracé_1652"
        data-name="Tracé 1652"
        class="cls-7"
        d="M333.83,596.35s1.543,1.286,1.266,2.447-.989,4.084-.989,4.084Z"
        transform="translate(-291.589 -535.732)"
      />
      <path
        id="Tracé_1653"
        data-name="Tracé 1653"
        class="cls-7"
        d="M223.412,578.45s-2.174.238-2.033.519,2.033-.26,2.033-.26Z"
        transform="translate(-194.663 -520.305)"
      />
      <path
        id="Tracé_1654"
        data-name="Tracé 1654"
        class="cls-7"
        d="M350.19,651.4s.138.175-.668,0-.211-.717-.211-.717Z"
        transform="translate(-304.749 -582.559)"
      />
      <path
        id="Tracé_1655"
        data-name="Tracé 1655"
        class="cls-7"
        d="M343.8,672.974a5.139,5.139,0,0,1-1.7,0C341.506,672.8,343.8,672.974,343.8,672.974Z"
        transform="translate(-298.632 -601.706)"
      />
      <path
        id="Tracé_1656"
        data-name="Tracé 1656"
        class="cls-7"
        d="M320.964,741.92s-.193-.211-1.161.175-1.355.4-1.637.276A15.558,15.558,0,0,1,320.964,741.92Z"
        transform="translate(-278.073 -661.149)"
      />
      <path
        id="Tracé_1657"
        data-name="Tracé 1657"
        class="cls-7"
        d="M337.753,576.28l-1.373,1.91S337.119,576.518,337.753,576.28Z"
        transform="translate(-293.787 -518.434)"
      />
      <path
        id="Tracé_1658"
        data-name="Tracé 1658"
        class="cls-7"
        d="M314.528,449.15s-.059.634-.945.881a2.42,2.42,0,0,0-1.054.447"
        transform="translate(-273.231 -408.862)"
      />
      <path
        id="Tracé_1659"
        data-name="Tracé 1659"
        class="cls-7"
        d="M295.438,415.88a3.789,3.789,0,0,1-2.388.653"
        transform="translate(-256.441 -380.187)"
      />
      <path
        id="Tracé_1660"
        data-name="Tracé 1660"
        class="cls-7"
        d="M316.78,539.842s.341.214,1.16-.722"
        transform="translate(-276.894 -486.406)"
      />
      <path
        id="Tracé_1661"
        data-name="Tracé 1661"
        class="cls-7"
        d="M371.906,465.418a.6.6,0,0,0-.2-.464l-.229-.276a1.062,1.062,0,0,0-.151-.155c-.138-.106-.315-.138-.459-.233"
        transform="translate(-323.514 -421.911)"
      />
    </g>
  </svg>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';

@Component
export default class SvgHomePointsPicto2 extends Vue {}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/general';

.primaire {
  fill: var(--v-stickers_primaire-base);
}
.secondaire {
  fill: var(--v-stickers_secondaire-base);
}
.dark {
  fill: #000;
  opacity: 0.2;
}
.background1 {
  fill: var(--v-stickers_secondaire-base);
  opacity: 0.08;
}
.background2 {
  fill: var(--v-stickers_secondaire-base);
  opacity: 0.08;
}
.hair {
  fill: #3f3d56;
}
.t-shirt {
  fill: #e8e8f0;
}
.woman-skin {
  fill: #fbbebe;
}
.man-skin {
  fill: #be6f72;
}
.man-jacket {
  fill: #1f1f1f;
}
.shoes {
  fill: #1f1f1f;
}
.woman-pants {
  fill: #1f1f1f;
}

.cls-99 {
  fill: #f0f;
}

.cls-1 {
  fill: var(--v-stickers_primaire-base);
}

.cls-1,
.cls-11,
.cls-2,
.cls-7,
.cls-9 {
  opacity: 0.1;
}

.cls-10,
.cls-2 {
  fill: var(--v-stickers_primaire-base);
}

.cls-3 {
  fill: url(#linear-gradient);
}

.cls-4 {
  fill: #be6f72;
}

.cls-5 {
  fill: #3f3d56;
}

.cls-6 {
  fill: var(--v-stickers_secondaire-base);
}

.cls-8 {
  fill: #e3e8f4;
}

.cls-11 {
  fill: #fff;
}

.cls-12 {
  fill: url(#linear-gradient-2);
}

.cls-13 {
  fill: #81b1ce;
}

.cls-14 {
  fill: #fbbebe;
}

.cls-15 {
  fill: #444053;
}

.cls-16 {
  fill: #e8e8f0;
}
</style>
